import React, { useState } from "react";

import styles from "./CheckboxInput.module.scss";
import block from 'bem-css-modules';

import { sanitizeContent as s, trackEvent } from "../../../../util/functions";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { IFieldProperties } from "../InputFields.types";

const CheckboxInput = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const {
    fieldData: {
      label,
      text,
      validationText,
      settings: [{
        crmProperty,
        required,
      }]
    },
    register,
    errors
  } = props;

  const b = block(styles);

  const [checked, setChecked] = useState(false);

  const handleCheckboxClick = () => {
    trackEvent(`formClient.field.checkbox.${!checked ? "checked" : "unchecked"}`, label);
    setChecked(!checked);
  };

  return (
    <div className={`${b()}`}>
      <label htmlFor={label}>
        <span className={`${b("checkbox")} ${checked && b("is-checked")}`}>
          <input
            id={label}
            data-crm-field={crmProperty}
            type="checkbox"
            onClick={handleCheckboxClick}
            {...register(
              label,
              {
                required: required
              }
            )}
          />
        </span>
        <span className={b("text")} dangerouslySetInnerHTML={{ __html: s(text) }} />
      </label>
      {errors[label] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default CheckboxInput;